import React, { useState,useEffect } from 'react';
import {useAppDispatch,useAppSelector} from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { Modal,Form, Input,App } from 'antd';
import { eventBus } from '@/utils/eventBus';
import styles from './AccountSecurity.module.scss';
import checkIcon from '@/assets/images/路径 1639@2x.png';
import { saveUserInfo } from '@/api/user';
import CookieUtil from '@/utils/cookies';
import { setUserInfo } from '@/store/slices/userSlice';
import { useTranslation } from 'react-i18next';
interface IForm {
  email:string; //邮箱
  phone:string; //手机号
};


const AccountSecurity: React.FC = () => {

  const {message} = App.useApp();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const userInfo = useAppSelector((state) => state.user.userInfo);

  //yourTownloopSearchValue关键字
  const yourTownloopSearchValue = useAppSelector((state)=>state.searchBar.yourTownloopSearchValue);
  
  // 修改邮件地址的模态框

  //useState和Ant Design 的 Form 组件关联起来需要用到Form.useForm()
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [emailOrPhone, setEmailOrPhone] = useState(true); //true是Email，false是Phone

  //表单数据
  const [formData, setFormData] = useState<IForm>({
    email: '434943281@qq.com',//You haven't logged in yet
    phone: '258-147-369',
  });

  //打开邮件修改
  const showModalEmail = () => {
    //给表单回传默认值
    form.setFieldsValue({ ...formData });
    setEmailOrPhone(true);
    setIsModalOpen(true);
  };

  //打开手机修改
  const showModalPhone = () => {
    //给表单回传默认值
    form.setFieldsValue({ ...formData });
    setEmailOrPhone(false);
    setIsModalOpen(true);
  };

  //提交表单
  const handleOk = () => {
    form
    .validateFields()
    .then(values => {
      console.log(values,'values');
      
     


      saveUserInfo({
        phone: values.phone,
      }).then((res)=>{
        if(res.code == 200){
          //把表单更新的内容更新给formData
          setFormData((prev)=>({
            ...prev,
            ...values
          }));

          setIsModalOpen(false);
          message.success('Update Success');

          const userInfo = CookieUtil.get('userInfo');
          if(!!userInfo){
            userInfo.phone = values.phone;
            CookieUtil.set('userInfo', userInfo);
            dispatch(setUserInfo(userInfo));
          }

        }
        
      });
    },()=>{
    });
  };

  //取消表单
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  // 检查密码和你的安全服务
  const Examine = () => {
    console.log('Examine');
    message.success('Operation successful');
    
  }

  

  //mounted 和unmounted
  useEffect(()=>{
    setFormData({
      email: userInfo?.email || '',
      phone: userInfo?.phone || '',
    });
    return ()=>{
      console.log('组件销毁时');
      //销毁清除townloopSearchValue的值
      eventBus.emit('deleteTownloopSearchValue');
      dispatch(clearYourTownloopSearchValue());
    }
  },[]);

  //yourTownloopSearchValue关键字的监听
  useEffect(()=>{
    console.log('AccountSecurity组件yourTownloopSearchValue',yourTownloopSearchValue);
    
   },[yourTownloopSearchValue])

  return (
    <div className={styles['account-box']}>
      {/* 基础信息区 */}
      <div className={styles['base-info']}> 
        <div className={styles['base-title']}>{t("AccountSecurity.YourBasicInformation")}</div>
        <div className={styles['base-info-list']}>
          <div className={styles['base-info-row']}>
            <span className={styles['base-info-label']}>{t("AccountSecurity.AccountName")}</span>
            <span className={styles['base-info-value']}>{userInfo?.first_name + ' ' + userInfo?.last_name}</span>
          </div>
          <div className={styles['base-info-row']}>
            <span className={styles['base-info-label']}>{t("AccountSecurity.LogInToAMailbox")}</span>
            <span className={styles['base-info-value']}>{formData.email}</span>
            {/* <span className={styles['base-info-action']} onClick={showModalEmail}>Add Email Address</span> */}
          </div>
          <div className={styles['base-info-row']}>
            <span className={styles['base-info-label']}>{t("AccountSecurity.Phone")}</span>
            <span className={styles['base-info-value']}>{formData.phone}</span>
            <span className={styles['base-info-action']} onClick={showModalPhone}>Modify Mobile Phone</span>
          </div>
        </div>
      </div>
      {/* 安全服务区 */}
      <div className={styles['security-title']}>{t("AccountSecurity.ModifyMobilePhone")}</div>
      <div className={styles['security-list']}>
        {/* 第一行 */}
        <div className={styles['security-row']}>
          <div className={styles['security-icon-col']}>
            <img src={checkIcon} alt="ok" className={styles['security-icon']} />
            <div className={styles['security-status']}>{t("AccountSecurity.Inuse")}</div>
          </div>
          <div className={styles['security-name']}>{t("AccountSecurity.YourSecurityService")}</div>
          <div className={styles['security-desc']}>
            {t("AccountSecurity.ItIsUsed")}
          </div>
          <div 
            className={styles['security-action']}
            onClick={Examine}
          >{t("AccountSecurity.Examine")}</div>
        </div>
        {/* 第二行 */}
        <div className={styles['security-row']}>
          <div className={styles['security-icon-col']}>
            <img src={checkIcon} alt="ok" className={styles['security-icon']} />
            <div className={styles['security-status']}>{t("AccountSecurity.Inuse")}</div>
          </div>
          <div className={styles['security-name']}>{t("AccountSecurity.LoginPassword")}</div>
          <div className={styles['security-desc']}>
            {t("AccountSecurity.APassword")}
          </div>
          <div 
            className={styles['security-action']}
            onClick={Examine}
          >{t("AccountSecurity.Examine")}</div>
        </div>
      </div>

      {/* 修改邮箱或手机号 */}
      <Modal
        title="Basic Modal"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            
            label="Email"
            name="email"
            rules={[{ required: true, message: 'Please input your email!' }]}
          >
            <Input disabled={!emailOrPhone}/>
          </Form.Item>
          <Form.Item
            label="Phone"
            name="phone"
            rules={[{ required: true, message: 'Please input your phone!' }]}
          >
            <Input disabled={emailOrPhone}/>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AccountSecurity; 